import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        // `w-fit`: a label's box must hug its text.
        //
        // `flex` alone made it fill its container, and `globals.css` gives `label[for]` a pointer
        // cursor — so on every labelled field in the app the hand, and a real click target,
        // extended the full width of the row. In a narrow drawer beside a short word like
        // "Deadline" that is most of the screen offering to do something it does not look like it
        // offers. The label stays clickable; it just stops being 400px wide.
        "flex w-fit items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
